import constants from '../constants';

import mixin from './mixin';

import SourceSet from './components/SourceSet.vue';

const defaultComponent = {
    mixins: [mixin],
    components: { SourceSet },
    props: {
        item: Object,
        inSidebar: Boolean,
    },
    data() {
        return {
            constants: constants,
        }
    },
    computed: {
        url() {
            if (this.item.link) return JSON.parse(this.item.link)[0].url;
            return this.item.url;
        },
        target() {
            if (this.item.link) return JSON.parse(this.item.link)[0].target;
            return null;
        },
        titleClass() {
            return this.inSidebar ? 'is-5' : 'is-4';
        },
        textClass() {
            return this.inSidebar ? '' : 'is-size-body';
        },
        contentClass() {
            return this.inSidebar ? 'px-0' : '';
        }
    },
};

export default defaultComponent;
